/* DefaultFailCommsSectionMgrComponent.js */

'use strict';
const EventEmitter = require('events').EventEmitter;
const Renderer = require('./DefaultFailCommsSectionMgrRenderer');
const ConnectionFactory = require('@gluenetworks/platform-sdk-remote').connectionFactories.ConnectionHandlerFactory;
const _ = require("lodash");

class DefaultFailCommsSectionMgrComponent extends EventEmitter {
    constructor(steve, logger, router, userFeedback) {
        super();
        this._steve = steve;
        this.log = logger;
        this._renderer = new Renderer(this, this.logger);
        this._connectionAttempts = 0;
        this._connection = ConnectionFactory.getInstance();
        this._router = router;
        this._userFeedback = userFeedback;
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._connection.on('ReconnectionAttempt', this._updateConnectionAttemptsHandler = this._updateConnectionAttemptsHandler.bind(this));
        this._connection.on('ReconnectionEstablished', this._onReconnectionEstablished = this._onReconnectionEstablished.bind(this));
        this._connection.on('ReconnectionFailed', this._onReconnectionFailed = this._onReconnectionFailed.bind(this));

    }

    _unregisterListeners() {
        this._connection.removeListener('ReconnectionAttempt', this._updateConnectionAttemptsHandler);
        this._connection.on('ReconnectionEstablished', this._onReconnectionEstablished);
        this._connection.on('ReconnectionFailed', this._onReconnectionFailed);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    getConnectionAttempts() {
        return this._connectionAttempts;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _updateConnectionAttemptsHandler(number) {
        console.log("Reconnection attempt #", number);
        this._connectionAttempts = number;
        this.emit('refreshAttempts');
    }

    _onReconnectionEstablished() {
        console.log("Connection reestablished");
        let routeDetails = this._router.getRouteDetails();
        if (routeDetails) {
            if (routeDetails.rd && !_.isEmpty(routeDetails.rd.redirect)) {
                this._router.replaceRouteInfo(routeDetails.rd.redirect);
            }
            else if (routeDetails.s !== "FailComms") {
                this._router.replaceRouteInfo(routeDetails);
            }
            else {
                this._router.goTo({app: "GameConsole", s: "LoginCenter"});
            }
        }
        else {
            this._router.goTo({app: "GameConsole", s: "LoginCenter"});
        }
    }

    _onReconnectionFailed() {
        this._userFeedback.displayNotification('Unable to reconnect to Gluware server. Please verify local network connectivity and try to reload again.',
            {notDismissable: true, title: "Unable to reconnect", confirmDetails: {text: "Reload"}})
            .then(() => {
                window.location = window.origin;
            });
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* Start Section Mgr API METHODS           */
    /*******************************************/

    shutDown() {
        this.emit('Shutdown');
        return Promise.resolve()
            .then(() => {
                this._unregisterListeners();
                this._steve = undefined;
                this.log = undefined;
                this._renderer = undefined;
            });
    }

    shutdown() {
        return this.shutDown();
    }

    /*******************************************/
    /* END Section Mgr API METHODS             */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = DefaultFailCommsSectionMgrComponent;

module.exports.$inject = [
    '$teve.core',
    '$teve.logger',
    '$teve.router',
    '$teve.ui.userFeedback'
];